<template>
  <div>
    <v-snackbar
      v-model="snackbar.show"
      top
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      multi-line
      min-height="48"
      :z-index="1000"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="onClose">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay
      :value="snackbar.show && snackbar.color === 'error'"
      :z-index="900"
    >
    </v-overlay>
  </div>
</template>

<script>
export default {
  computed: {
    snackbar: {
      // getter
      get: function () {
        return this.$store.state.snackbar
      },
      // setter
      set: function () {
        // do something !
      },
    },
  },
  methods: {
    onClose() {
      this.$store.state.snackbar.show = false
    },
  },
}
</script>
